<script setup lang="ts">
import BundleCardSection from './card-section/sections/BundleCardSection.vue';
import HotelCardSection from './card-section/sections/HotelCardSection.vue';
import HotelCardLoader from './card-section/sections/HotelCardLoader.vue';
import type HotelPackage from '@itinerary/hotel/HotelPackage';
import { LoadingStatus } from '@itinerary/ItineraryModuleTypes';
import { ReserveType } from '@utils/itinerary';
import { useReserve } from '@composable/_local/hotel&view/useReserve';
import type BundlePackage from '@itinerary/bundle/BundlePackage';

defineProps<{
    showHotelsOnMap?: boolean;
}>();

const emit = defineEmits<{
    closeMap: [];
    openFilters: [];
    view: [];
}>();

const itineraryStore = useItineraryStore();
const searchFormStore = useSearchFormStore();
const { reservableList, loading } = storeToRefs(itineraryStore);
const mapHotelList = computed(() =>
    (reservableList.value as HotelPackage[])
        .slice()
        .sort((a, b) => (a.latitude || 0) - (b.latitude || 0))
);
const currentModule = useCurrentItineraryModule();
const { currentLoadingStatus } = moduleToRefs(currentModule.value);
const { reserveType } = storeToRefs(searchFormStore);
const isMounted = useMounted();

const isHotelReserve = computed(() => reserveType.value === ReserveType.Hotel);
const isBundleReserve = computed(
    () => reserveType.value === ReserveType.Bundle
);
const { reserveBundle } = useReserve();
const isLoading = computed(
    () =>
        loading.value ||
        currentLoadingStatus.value === LoadingStatus.None ||
        !process.client ||
        !isMounted.value
);
</script>
<template>
    <HotelCardLoader v-if="isLoading" :count="4" />
    <template v-else>
        <HotelCardSection
            v-if="isHotelReserve"
            key="hotel-reservable-list"
            class="cards-container"
            display-banners
            :list="reservableList as HotelPackage[]"
            :map-hotel-list
            :show-map="showHotelsOnMap && isHotelReserve"
            @view-section="emit('view')"
            @close-map="emit('closeMap')"
            @open-filters="emit('openFilters')"
        />
        <BundleCardSection
            v-else-if="isBundleReserve"
            key="bundle-reservable-list"
            class="cards-container"
            display-banners
            :show-map="showHotelsOnMap && isBundleReserve"
            :list="reservableList as BundlePackage[]"
            @view-section="emit('view')"
            @close-map="emit('closeMap')"
            @reserve="reserveBundle"
        />
    </template>
</template>
<style scoped lang="scss">
.cards-container {
    margin-top: 4px;
}
</style>
